import type {PhoneNumbersAction} from 'src/action-creators/phone-numbers';

import omit from 'lodash/omit';
import keyBy from 'lodash/keyBy';

import {
  RECEIVE_PHONE_NUMBERS,
  ADD_AGENT_PHONE_NUMBER_ASSIGNMENT,
  REMOVE_AGENT_PHONE_NUMBER_ASSIGNMENT,
  ADD_INVITE_PHONE_NUMBER_ASSIGNMENT,
  REMOVE_INVITE_PHONE_NUMBER_ASSIGNMENT,
  RECEIVE_PHONE_CAPABILITIES,
  SET_MESSAGING_CALL_FORWARDING_NUMBER,
  SET_FRIENDLY_NAME,
} from 'src/action-creators/phone-numbers';

import {selectDisplayPhoneNumber} from 'src/selectors/chat';


export type PhoneNumbersState = {
  user_invites: Array<{
    [invite_code: string]: {
      [key: string]: any;
    };
  }>;
  user_accounts: Array<{
    [agent_id: string]: {
      [key: string]: any;
    };
  }>;
  phone_numbers: {
    [provisioned_phone_id: string]: string;
  };
  invite_assignments: {
    [invite_code: string]: Array<number>;
  };
  agents: Array<{
    [agent_id: string]: {
      [key: string]: any;
    };
  }>;
  agent_assignments: {
    [agent_id: string]: Array<number>;
  };
  phone_capabilities: {
    [phone_number: string]: {
      [key: string]: boolean;
    };
  };
  call_forwarding_numbers: {
    [provisioned_phone_id: string]: string;
  };
  friendly_names: {
    [provisioned_phone_id: string]: string;
  };
};

const phoneNumbersState = {
  user_invites: [],
  user_accounts: [],
  phone_numbers: Object.freeze({}),
  invite_assignments: Object.freeze({}),
  agents: [],
  agent_assignments: Object.freeze({}),
  phone_capabilities: Object.freeze({}),
  call_forwarding_numbers: Object.freeze({}),
  friendly_names: Object.freeze({}),
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly user_invites: readonly []; readonly user_accounts: readonly []; readonly phone_numbers: Readonly<{}>; readonly invite_assignments: Readonly<{}>; readonly agents: readonly []; readonly agent_assignments: Readonly<...>; readonly phone_capabilities: Readonly<...>; readonly call_forwarding_numbers: Readonly<....' is not assignable to type 'PhoneNumbersState'.
  state: PhoneNumbersState | null | undefined = phoneNumbersState,
  action: PhoneNumbersAction,
): PhoneNumbersState => {
  switch (action.type) {
    case RECEIVE_PHONE_NUMBERS: {
      return {
        ...state,
        // @ts-expect-error - TS2698 - Spread types may only be created from object types.
        ...action.payload,
      };
    }
    case SET_MESSAGING_CALL_FORWARDING_NUMBER: {
      const {call_forwarding_number, provisioned_phone_id} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ call_forwarding_numbers: {}; user_invites?: { [invite_code: string]: { [key: string]: any; }; }[] | undefined; user_accounts?: { [agent_id: string]: { [key: string]: any; }; }[] | undefined; phone_numbers?: { ...; } | undefined; ... 4 more ...; friendly_names?: { ...; } | undefined; }' is not assignable to type 'PhoneNumbersState'.
      return {
        ...state,
        call_forwarding_numbers: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.call_forwarding_numbers,
          [provisioned_phone_id]: call_forwarding_number,
        },
      };
    }
    case SET_FRIENDLY_NAME: {
      const {friendly_name, provisioned_phone_id} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ friendly_names: {}; user_invites?: { [invite_code: string]: { [key: string]: any; }; }[] | undefined; user_accounts?: { [agent_id: string]: { [key: string]: any; }; }[] | undefined; phone_numbers?: { ...; } | undefined; ... 4 more ...; call_forwarding_numbers?: { ...; } | undefined; }' is not assignable to type 'PhoneNumbersState'.
      return {
        ...state,
        friendly_names: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.friendly_names,
          [provisioned_phone_id]: friendly_name,
        },
      };
    }
    case ADD_AGENT_PHONE_NUMBER_ASSIGNMENT: {
      const {agent_id, provisioned_phone_id} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ agent_assignments: { [x: string]: number[] | number[]; }; user_invites?: { [invite_code: string]: { [key: string]: any; }; }[] | undefined; user_accounts?: { [agent_id: string]: { [key: string]: any; }; }[] | undefined; ... 5 more ...; friendly_names?: { ...; } | undefined; }' is not assignable to type 'PhoneNumbersState'.
      return {
        ...state,
        agent_assignments: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.agent_assignments,
          [agent_id]: [
            // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
            ...(state.agent_assignments[agent_id] || []),
            provisioned_phone_id,
          ],
        },
      };
    }
    case REMOVE_AGENT_PHONE_NUMBER_ASSIGNMENT: {
      const {agent_id, provisioned_phone_id} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ agent_assignments: { [x: string]: number[]; }; user_invites?: { [invite_code: string]: { [key: string]: any; }; }[] | undefined; user_accounts?: { [agent_id: string]: { [key: string]: any; }; }[] | undefined; ... 5 more ...; friendly_names?: { ...; } | undefined; }' is not assignable to type 'PhoneNumbersState'.
      return {
        ...state,
        agent_assignments: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.agent_assignments,
          [agent_id]:
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
            state.agent_assignments[agent_id]?.filter(
              (id: number) => String(id) !== String(provisioned_phone_id),
            ) || [],
        },
      };
    }
    case ADD_INVITE_PHONE_NUMBER_ASSIGNMENT: {
      const {invite_code, provisioned_phone_id} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ invite_assignments: { [x: string]: number[] | number[]; }; user_invites?: { [invite_code: string]: { [key: string]: any; }; }[] | undefined; user_accounts?: { [agent_id: string]: { [key: string]: any; }; }[] | undefined; ... 5 more ...; friendly_names?: { ...; } | undefined; }' is not assignable to type 'PhoneNumbersState'.
      return {
        ...state,
        invite_assignments: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.invite_assignments,
          [invite_code]: [
            // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
            ...(state.invite_assignments[invite_code] || []),
            provisioned_phone_id,
          ],
        },
      };
    }
    case REMOVE_INVITE_PHONE_NUMBER_ASSIGNMENT: {
      const {invite_code, provisioned_phone_id} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ invite_assignments: { [x: string]: number[]; }; user_invites?: { [invite_code: string]: { [key: string]: any; }; }[] | undefined; user_accounts?: { [agent_id: string]: { [key: string]: any; }; }[] | undefined; ... 5 more ...; friendly_names?: { ...; } | undefined; }' is not assignable to type 'PhoneNumbersState'.
      return {
        ...state,
        invite_assignments: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.invite_assignments,
          [invite_code]:
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
            state.invite_assignments[invite_code]?.filter(
              (code: number) => String(code) !== String(provisioned_phone_id),
            ) || [],
        },
      };
    }
    case RECEIVE_PHONE_CAPABILITIES: {
      const {phoneNumber, capabilities} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ phone_capabilities: { [x: string]: PhoneCapabilities; }; user_invites?: { [invite_code: string]: { [key: string]: any; }; }[] | undefined; user_accounts?: { [agent_id: string]: { [key: string]: any; }; }[] | undefined; ... 5 more ...; friendly_names?: { ...; } | undefined; }' is not assignable to type 'PhoneNumbersState'.
      return {
        ...state,
        phone_capabilities: {
          [phoneNumber]: capabilities,
        },
      };
    }
  }
  // @ts-expect-error - TS2322 - Type 'PhoneNumbersState | null' is not assignable to type 'PhoneNumbersState'.
  return state;
};
